/**
 * 직접거래 시작 모달
 */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './TradeModal.css';

interface TradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: TradeFormData) => void;
  loading: boolean;
}

export interface TradeFormData {
  title: string;
  description: string;
  agreedPrice: number | null;
}

const TradeModal: React.FC<TradeModalProps> = ({ isOpen, onClose, onSubmit, loading }) => {
  const { t } = useTranslation();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [agreedPrice, setAgreedPrice] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({
      title: title || t('tradeModal.defaultTitle'),
      description,
      agreedPrice: agreedPrice ? parseInt(agreedPrice.replace(/,/g, '')) : null
    });
  };

  const formatPrice = (value: string) => {
    const num = value.replace(/[^\d]/g, '');
    return num ? parseInt(num).toLocaleString() : '';
  };

  const handleClose = () => {
    setTitle('');
    setDescription('');
    setAgreedPrice('');
    onClose();
  };

  return (
    <div className="trade-modal-overlay" onClick={handleClose}>
      <div className="trade-modal" onClick={(e) => e.stopPropagation()}>
        <div className="trade-modal-header">
          <h2>🤝 {t('tradeModal.title')}</h2>
          <button className="close-btn" onClick={handleClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="trade-modal-body">
            <div className="form-notice info">
              <strong>💡 {t('tradeModal.noticeTitle')}</strong>
              <p>{t('tradeModal.noticeDesc')}</p>
            </div>

            <div className="form-group">
              <label>{t('tradeModal.titleLabel')}</label>
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder={t('tradeModal.titlePlaceholder')}
              />
            </div>

            <div className="form-group">
              <label>{t('tradeModal.descLabel')}</label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder={t('tradeModal.descPlaceholder')}
                rows={3}
              />
            </div>

            <div className="form-group">
              <label>{t('tradeModal.priceLabel')}</label>
              <div className="price-input-wrapper">
                <input
                  type="text"
                  value={agreedPrice}
                  onChange={(e) => setAgreedPrice(formatPrice(e.target.value))}
                  placeholder="0"
                />
                <span className="price-suffix">{t('tradeModal.wonSuffix')}</span>
              </div>
              <p className="form-hint">{t('tradeModal.hint')}</p>
            </div>

            <div className="form-notice warning">
              <strong>⚠️ {t('tradeModal.warnTitle')}</strong>
              <ul>
                <li>{t('tradeModal.warn1')}</li>
                <li>{t('tradeModal.warn2')}</li>
                <li>{t('tradeModal.warn3')}</li>
              </ul>
            </div>
          </div>

          <div className="trade-modal-footer">
            <button type="button" className="cancel-btn" onClick={handleClose}>{t('common.cancel')}</button>
            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? t('tradeModal.processing') : t('tradeModal.startTrade')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TradeModal;
